module.exports = __webpack_public_path__ + "img/course-empty.3f467fe8.png";